import { Component, Inject, HostListener } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Component({
    selector: 'management',
    templateUrl:'./management.component.html',
    styleUrls: ['./management.component.css'],
})

export class ManagementComponent {
    constructor(public permissions: PermissionsService) {
    }

    showSidebar: boolean = true;
    showButton: boolean = false;

    ngOnInit() {
    }
    
}
